import { useEffect, useRef, useState } from 'react';
import { obtenerProyectoAdm, obtenerPuestoAdm } from '../../services/Monitor/MonitorService';
import { creaHorarioComTotal, getHorarioByPuesto, obtenerDetalleHorario, obtenerHorarios, obtenerHorariosConDetalle } from '../../services/HorarioTurno/TurnoService';
import { obtenerConfiguracionDet } from '../../services/Configuracion/ConfiguracionDetService';

export const useConfigFrecuencia = () => {
    const [proyecto, setProyecto] = useState();
    const [lstProyecto, setLstProyecto] = useState([]);
    const [cargaProyecto, setCargaProyecto] = useState(true);
    const [puesto, setPuesto] = useState();
    const [lstPuesto, setLstPuesto] = useState([]);
    const [cargaPuesto, setCargaPuesto] = useState(false);
    const [horario, setHorario] = useState();
    const [lstHorario, setLstHorario] = useState([]);
    const [cargaHorario, setCargaHorario] = useState(false);
    const [detHorario, setDetHorario] = useState();
    const [lstDetHorario, setLstDetHorario] = useState([]);
    const [cargaDetHorario, setCargaDetHorario] = useState(false);

    const [estadoConf, setEstadoConf] = useState();
    const [lstEstadoConf, setLstEstadoConf] = useState([]);
    const [cargaEstadoConf, setCargaEstadoConf] = useState(false);

    const [cantidad, setCantidad] = useState(0);
    const [esAleatorio, setEsAleatorio] = useState(false);
    const [procesando, setProcesando] = useState(false);
    const [ctrlDisabled, setCtrlDisabled] = useState(true);
    const [intervalo, setIntervalo] = useState(0);

    const [limInf, setLimInf] = useState(0);
    const [limSup, setLimSup] = useState(0);
    const [disabledRandom, setDisabledRandom] = useState(true);
    const [multiPuesto, setMultiPuesto] = useState();
    const [tolerancia, setTolerancia] = useState(0);

    const toast = useRef(null);

    const [renderKey, setRenderKey] = useState(0);

    useEffect(() => {
        const cargarProyecto = async () => {
            try {
                const datos = await obtenerProyectoAdm();
                //console.log ('ww01', datos)
                setLstProyecto(datos);
                setCargaProyecto(false);
            } catch (error) {
                console.error(error.message);
            }
        };
        cargarProyecto();
    }, []);

    useEffect(() => {
        const cargaEstadoConf = async () => {
            setCargaEstadoConf(true);
            try {
                const codeConfCab = 'TUR-0000-0001';
                const datos = await obtenerConfiguracionDet(codeConfCab);
                setLstEstadoConf(datos);
                const elegido = datos.find((item) => item.codigo === 'TUR-0000-0001-0000');
                if (elegido) setEstadoConf(elegido);
            } catch (error) {
                console.error(error.message);
            } finally {
                setCargaEstadoConf(false);
            }
        };
        cargaEstadoConf();
    }, []);

    useEffect(() => {
        const cargarPuesto = async () => {
            if (proyecto) {
                setCargaPuesto(true);
                setMultiPuesto([])
                try {
                    const datos = await obtenerPuestoAdm(proyecto.id);
                    //console.log('KK00:', datos)
                    setLstPuesto(datos);
                } catch (error) {
                    console.error(error.message);
                }
                setCargaPuesto(false);
            }
        };
        cargarPuesto();
    }, [proyecto]);

    useEffect(() => {
        const recuperaHorarios = async (lstPuestos) => {
            //console.log('88=', lstPuestos)
            const lstIds = lstPuestos?.map((item) => item.id);
            //console.log('99=', lstIds)
            try {
                setCargaHorario(true);
                const data = await getHorarioByPuesto(lstIds);
                setLstHorario(data);
            } catch (error) {
                console.error(error.message);
            } finally {
                setCargaHorario(false);
            }
        };

        if (multiPuesto && multiPuesto?.length !== 0) {
            recuperaHorarios(multiPuesto);
        } else {
            setLstHorario([]);
        }
    }, [multiPuesto]);

    /*useEffect(() => {
        const cargarHorario = async () => {
            setCargaHorario(true);
            try {
                //const datos = await obtenerHorarios();
                const datos = await obtenerHorariosConDetalle();
                //console.log('JJ01', datos);
                setLstHorario(datos);
            } catch (error) {
                console.error(error.message);
            }
            setCargaHorario(false);
        };
        cargarHorario();
    }, []);  */

    useEffect(() => {
        const cargaDetalleHor = async () => {
            if (horario) {
                setCargaDetHorario(true);
                try {
                    const datos = await obtenerDetalleHorario(horario.horarioId);
                    setLstDetHorario(datos);
                    //console.log('XX01', datos);
                    if (datos.length === 1) {
                        // si solo es uno elejirlo por defecto
                        setDetHorario(datos[0]);
                    }
                    // deshabilitar los controles
                    setCtrlDisabled(false);
                    setDiasSelect(diasSemana);
                } catch (error) {
                    console.error(error.message);
                }
                setCargaDetHorario(false);
            }
        };
        cargaDetalleHor();
    }, [horario]);

    const horarioItemTemplate = (itemFila) => {
        return (
            <span>
                {itemFila.sigla} - {itemFila.nombre}
            </span>
        );
    };
    const horarioSelectTemplate = (itemFila, props) => {
        if (itemFila) {
            return (
                <span>
                    {itemFila.sigla} - {itemFila.nombre}
                </span>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    const turnoItemTemplate = (itemFila) => {
        return <span> {itemFila.horarioLiteral} </span>;
    };
    const turnoSelectTemplate = (itemFila, props) => {
        if (itemFila) {
            return <span>{itemFila.horarioLiteral}</span>;
        }
        return <span>{props.placeholder}</span>;
    };

    const handleCheckAleatorio = (evt) => {
        setEsAleatorio(evt.checked);
        evt.checked ? setDisabledRandom(false) : setDisabledRandom(true);
    };

    const handleClick = async () => {
        if (!(proyecto && multiPuesto && horario && estadoConf && tolerancia)) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Debe elegir Proyecto, Puesto, Horario, Estado y Tolerancia', life: 3000 });
            return;
        }
        if (esAleatorio) {
            if (!(limInf && limSup)) {
                toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Debe llenar Los campos limite Inferior y Superior y la Frecuencia', life: 3000 });
                return;
            }
        } else {
            if (!(cantidad && intervalo)) {
                toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Debe llenar el campo cantidad', life: 3000 });
                return;
            }
        }
        if (diasSelect.length === 0) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Debe Seleccionar al menos un dia de Semana', life: 3000 });
            return;
        }

        //console.log ('ZZ00=', diasSelect);
        if (multiPuesto.length === 0) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Deben haber Puestos Seleccionados', life: 3000 });
            return;
        }

        const lstSiglas = multiPuesto.map((item) => item.sigla).filter((sigla) => sigla !== null && sigla !== undefined);
        
        const objData = {
            proyectoId: proyecto.id,
            puestoSiglaList: lstSiglas,
            horarioSigla: horario.sigla,
            cantidadVeces: cantidad,
            esAleatorio: esAleatorio,
            usuarioOperador: 1,
            intervalo: intervalo,
            randomLimInf: limInf,
            randomLimSup: limSup,
            estado: estadoConf.configuracionDetId,
            tolerancia: tolerancia,
            lunes: diasSelect.some((item) => item.id === 1),
            martes: diasSelect.some((item) => item.id === 2),
            miercoles: diasSelect.some((item) => item.id === 3),
            jueves: diasSelect.some((item) => item.id === 4),
            viernes: diasSelect.some((item) => item.id === 5),
            sabado: diasSelect.some((item) => item.id === 6),
            domingo: diasSelect.some((item) => item.id === 7)
        };

        try {
            setProcesando(true);
            setCtrlDisabled(true); //pruebas
            const data = await creaHorarioComTotal(objData);
            //console.log('ZZ02:', data);
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Generado exitosamente', life: 3000 });
            setProyecto(null);
            setPuesto(null);
            setHorario(null);
            setDetHorario(null);
            setCantidad(1);
            setIntervalo(1);
            setLimInf(1);
            setLimSup(1);
            setEsAleatorio(false);
            setCtrlDisabled(true);
            setDisabledRandom(true);
            setTolerancia(10);
            setRenderKey((prevKey) => prevKey + 1);
            setDiasSelect([]);
            setMultiPuesto([]);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al registrar Configuración', life: 3000 });
        } finally {
            setProcesando(false);
        }

        return;
    };

    const controlDisabledIntervalo = () => {
        if (ctrlDisabled === true) {
            return true;
        }
        if (disabledRandom === true) return false;
        else return true;
    };

    //*****
    const [diasSemana] = useState([
        { id: 1, nombre: 'Lunes' },
        { id: 2, nombre: 'Martes' },
        { id: 3, nombre: 'Miércoles' },
        { id: 4, nombre: 'Jueves' },
        { id: 5, nombre: 'Viernes' },
        { id: 6, nombre: 'Sábado' },
        { id: 7, nombre: 'Domingo' }
    ]);

    const [diasSelect, setDiasSelect] = useState([]);

    return {
        toast,
        cargaProyecto,
        proyecto,
        setProyecto,
        lstProyecto,
        cargaPuesto,
        puesto,
        setPuesto,
        lstPuesto,
        cargaHorario,
        horario,
        lstHorario,
        horarioItemTemplate,
        horarioSelectTemplate,
        setHorario,
        cargaDetHorario,
        detHorario,
        lstDetHorario,
        turnoItemTemplate,
        turnoSelectTemplate,
        setDetHorario,
        cantidad,
        setCantidad,
        ctrlDisabled,
        esAleatorio,
        setEsAleatorio,
        handleClick,
        procesando,
        intervalo,
        setIntervalo,
        handleCheckAleatorio,
        disabledRandom,
        limInf,
        limSup,
        setLimInf,
        setLimSup,
        controlDisabledIntervalo,
        multiPuesto,
        setMultiPuesto,
        cargaEstadoConf,
        estadoConf,
        setEstadoConf,
        lstEstadoConf,
        tolerancia,
        setTolerancia,
        diasSemana,
        diasSelect,
        setDiasSelect,
        renderKey
    };
};
